import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "./Footer";

export function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-[100dvh] flex flex-col items-center px-4 py-8">
      <div className="w-full max-w-2xl">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-[var(--numex-muted)] hover:text-[var(--numex-ink)] transition-colors"
          data-testid="back-to-game"
        >
          <ArrowLeft size={16} /> Back to NUMEX
        </Link>

        <header className="mt-6 mb-6">
          <div className="font-mono text-base font-bold tracking-tight text-[var(--numex-ink)]">÷X</div>
          <h1 className="mt-1 text-3xl font-extrabold tracking-tight">{title}</h1>
          <p className="mt-1 text-xs text-[var(--numex-muted)]">Last updated: {updated}</p>
        </header>

        <article className="numex-legal space-y-5 text-[15px] leading-relaxed text-[var(--numex-ink)]">
          {children}
        </article>

        <Footer />
      </div>
    </div>
  );
}
